<template>
  <div>
    <textarea :id="id"></textarea>

    <a-modal v-model:visible="markeChangeHtmlVisible" title="Markdown" width="1200px" @cancel="markeChangeHtmlClose"
             @ok="markeChangeHtmlSubmit">
      <div style="display: flex;">
        <div style="position: relative;left: -10px">
          <p style="position: absolute;top: -27px; width: 100%">Markdown</p>
          <textarea rows="6" type="textarea" id="markedCkInput"
                    style="width: 500px;height:500px;border: 1px solid #d9d9d9;border-radius: 4px "></textarea>
          <div style="text-align: right;position: relative;top: 10px">
            <a-button type="primary" @click="cuert"> 生成</a-button>
          </div>
        </div>
        <div style="  padding: 0 10px;position: relative;flex: 1;right: -10px">
          <div style="position: absolute;top: -27px; width: 100%">主题：
            <span style="cursor: pointer;margin-right: 5px" @click="changeColor('#0f4c81')">蓝色</span>
            <span style="cursor: pointer;margin-right: 5px" @click="changeColor('#fa5151')">红色</span>
            <span style="cursor: pointer;margin-right: 5px" @click="changeColor('#fece00')">黄色</span>
            <span style="cursor: pointer;margin-right: 5px" @click="changeColor('#009874')">绿色</span>
          </div>
          <div class="markedCkBox">
            <div class="markedCcontent"></div>
          </div>

        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import CKEDITOR from "CKEDITOR"
// import { marked } from 'marked';
export default {
  name: 'ckeditors',
  props: [
    'value', "parameter", "width", "height"
  ],
  mounted: function () {
    window.markeChangeHtml = this.openMark.bind(this);
    const self = this
    // 渲染编辑器
    // self.ckeditor = window.CKEDITOR.replace(self.id)
    // CKEditor 配置项
    let ckConfig = {
      toolbarGroups: [
        {name: 'clipboard', groups: ['clipboard', 'undo']},
        {name: 'editing', groups: ['find', 'selection', 'spellchecker']},
        {name: 'links'},
        {name: 'insert'},
        {name: 'forms'},
        {name: 'tools'},
        {name: 'document', groups: ['mode', 'document', 'doctools']},
        {name: 'others'},
        '/',
        {name: 'basicstyles', groups: ['basicstyles', 'cleanup']},
        {name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align', 'bidi']},
        {name: 'styles'},
        {name: 'colors'},
        {name: 'about'},
        // {name:'markdown'}
      ],
      extraPlugins: 'markdown',
      fileTools_requestHeaders: {
        "Authorization": window.sessionStorage.getItem('signature')
      },
      filebrowserImageUploadUrl: this.parameter == 1
          ? this.$store.state.emailEditorUpload
          : this.$store.state.ckeditorsUrl,
      filebrowserUploadUrl: this.$store.state.ckeditorsUrl,
      // filebrowserImageUploadUrl: 'http://192.168.1.179/demo_vue/public/home/demo/editorUpload',
      filebrowserUploadMethod: 'xhr',
      image_previewText: '',
      disallowedContent: 'img{width,height,float}',
      extraAllowedContent: 'img[width,height,align];span{background}',
      allowedContent: true,

      // wordcount: {
      //     countHTML: true,
      //     // Whether or not you want to show the Word Count
      //     showWordCount: false,
      //     // Whether or not you want to show the Char Count
      //     showCharCount: true,
      //     // Maximum allowed Word Count
      //     maxWordCount: 0,
      //     // Maximum allowed Char Count
      //     maxCharCount: 10000
      // }
    }
    self.width ? ckConfig.width = self.width : '';
    self.height ? ckConfig.height = self.height : ckConfig.height = 400;
    self.ckeditor = CKEDITOR.replace(self.id, ckConfig)
    // 监听内容变更事件
    self.ckeditor.on('change', function () {
      // self.$emit("changCkNum", self.ckeditor.getData().length);
      self.$emit("changCkNums", self.ckeditor.getData().length);
      // setTimeout(() => {
      //     self.$emit('input', self.ckeditor.getData())
      // },500)
    })
    self.ckeditor.on('instanceReady', function (e) {
      self.typea = true
      self.$emit("instanceReadyCk", self.typea);
    });
    this.$on('getText', function () {
      self.$emit('input', self.ckeditor.getData())
    });
  },
  data: function () {
    return {
      values: "",
      id: parseInt(Math.random() * 10000).toString(),
      ckeditor: null,
      types: 1,
      typea: null,
      markeChangeHtmlVisible: false
    }
  },
  watch: {
    // 监听prop的变化，更新ckeditor中的值
    value: function () {
      let self = this
      self.ckeditor.setData(self.value)
    },
  },
  methods: {
    openMark() {
      this.markeChangeHtmlVisible = true
    },
    changeColor(color) {
      const element = document.getElementsByClassName("markedCkBox")[0];
      // 修改 CSS 变量
      element.style.setProperty("--color-base", color);   // 修改颜色
    },
    cuert() {
      let markdownText = document.getElementById('markedCkInput').value
      document.getElementsByClassName('markedCcontent')[0].innerHTML = window.marked.marked(markdownText)
    },
    markeChangeHtmlSubmit() {
      let style = `<style>
                .markedCkBox{--color-base: #009874;}
.markedCkBox h1 {font-size: 4vh;line-height: 1.75;display: table;padding: 9px 18px;border-bottom: 2px solid var(--color-base);margin: 36px auto 18px;font-weight: bold;text-align: center;text-shadow: 1px 1px 3px rgba(0,0,0,0.05);}
.markedCkBox h2{font-size: 20.8px;line-height: 1.75;display: table;padding: 4.8px 19.2px;margin: 48px auto 32px;color: #fff;background: var(--color-base);font-weight: bold;text-align: center;border-radius: 8px 24px 8px 24px;box-shadow: 0 2px 6px rgba(0,0,0,0.06);}
.markedCkBox h3{font-size: 19.2px;line-height: 2.4;padding-left: 12px;border-left: 4px solid var(--color-base);margin: 32px 8px 12px 0;font-weight: bold;border-radius: 6px;border-right: 1px solid rgba(59, 130, 246, 0.1);border-bottom: 1px solid rgba(59, 130, 246, 0.1);border-top: 1px solid rgba(59, 130, 246, 0.1);background: rgba(59, 130, 246, 0.08);}
.markedCkBox strong{font-size: inherit;line-height: 1.75;color: var(--color-base);font-weight: bold;}
.markedCkBox code{font-size: 16.2px;line-height: 1.75;color: #c7254e;background-color: rgba(0, 0, 0, 0.04);border-radius: 3px;padding: 3.6px 7.2px;}</style>`
      this.ckeditor.insertHtml(`${style}${document.getElementsByClassName('markedCkBox')[0].outerHTML}`)
      this.markeChangeHtmlClose()

    },
    markeChangeHtmlClose() {
      this.markeChangeHtmlVisible = false
      document.getElementById('markedCkInput').value = ''
      document.getElementsByClassName('markedCcontent')[0].innerHTML = ''
    }
    // getText(){
    //     self.$emit('input', self.ckeditor.getData())
    // }
  },
  // 销毁组件前，销毁编辑器
  beforeDestroy() {
    this.ckeditor.destroy()
    delete window.markeChangeHtml;
    // self.ckeditor.instances.editor1.destroy();
  }
}

</script>
<style>
.markedCkBox {

  --color-base: #009874;
}

.markedCkBox h1 {
  font-size: 4vh;
  line-height: 1.75;
  display: table;
  padding: 9px 18px;
  border-bottom: 2px solid var(--color-base);
  margin: 36px auto 18px;
  font-weight: bold;
  text-align: center;
  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.05);
}

.markedCkBox h2 {
  font-size: 20.8px;
  line-height: 1.75;
  display: table;
  padding: 4.8px 19.2px;
  margin: 48px auto 32px;
  color: #fff;
  background: var(--color-base);
  font-weight: bold;
  text-align: center;
  border-radius: 8px 24px 8px 24px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
}

.markedCkBox h3 {
  font-size: 19.2px;
  line-height: 2.4;
  padding-left: 12px;
  border-left: 4px solid var(--color-base);
  margin: 32px 8px 12px 0;
  font-weight: bold;
  border-radius: 6px;
  border-right: 1px solid rgba(59, 130, 246, 0.1);
  border-bottom: 1px solid rgba(59, 130, 246, 0.1);
  border-top: 1px solid rgba(59, 130, 246, 0.1);
  background: rgba(59, 130, 246, 0.08);
}

.markedCkBox strong {
  font-size: inherit;
  line-height: 1.75;
  color: var(--color-base);
  font-weight: bold;
}

.markedCkBox code {
  font-size: 16.2px;
  line-height: 1.75;
  color: #c7254e;
  background-color: rgba(0, 0, 0, 0.04);
  border-radius: 3px;
  padding: 3.6px 7.2px;
}

.markedCcontent {
  max-height: 500px;
  overflow: auto;
}
</style>